class ComparisonTable extends HTMLElement {
  constructor() {
    super();

    this.productDescriptions = this.querySelectorAll('[data-product-description]');
    this.productAttributes = Array.from(this.querySelector('[data-slide-index="1"]').querySelectorAll('[data-product-attr]'));
    this.loadMore = this.querySelector('[data-load-more]');

    this.init('init');

    window.addEventListener(
      'resize',
      debounce(() => {
        this.init('init');
      }, 50),
    );

    document.addEventListener('shopify:section:load', () => this.init('load event'));
    document.addEventListener('shopify:section:reorder', () => this.init('reorder event'));
    document.addEventListener('shopify:section:select', () => this.init('select event'));

    this.loadMore.addEventListener('click', () => {
      if (this.loadMore.getAttribute('data-load-more') === 'hidden') {
        this.loadMore.querySelector('[data-show-more-label]').classList.add('hidden');
        this.loadMore.querySelector('[data-show-less-label]').classList.remove('hidden');
        this.loadMore.setAttribute('data-load-more', 'visible');

        this.querySelectorAll('[data-product-attr-hidden]').forEach(item => {
          item.classList.remove('hidden');
        });

        setTimeout(() => {
          this.productAttributes.filter(item => item.dataset.productAttrHidden === '').forEach(item => {
            let maxHeightAttr = 0;
            let attributeIndex = item.getAttribute('data-product-attr');
            let attributeFields = this.querySelectorAll(`[data-product-attr="${attributeIndex}"]`);
            attributeFields.forEach(field => {
              if (field.getBoundingClientRect().height > maxHeightAttr) {
                maxHeightAttr = field.getBoundingClientRect().height;
              }
            });
            attributeFields.forEach(field => {
              field.style.height = maxHeightAttr + 'px';
            });
          });
        }, 500);
      }
      else {
        this.loadMore.querySelector('[data-show-more-label]').classList.remove('hidden');
        this.loadMore.querySelector('[data-show-less-label]').classList.add('hidden');
        this.loadMore.setAttribute('data-load-more', 'hidden');

        this.querySelectorAll('[data-product-attr-hidden]').forEach(item => {
          item.classList.add('hidden');
        });
      }
    });
  }

  init(type) {
    let timeOut = 0;
    if (type !== 'init') {
      timeOut = 500;
    }
    setTimeout(() => {
      // Find the product description with the highest height
      let maxHeight = 0;
      this.productDescriptions.forEach(description => {
        const height = description.getBoundingClientRect().height;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Update all product descriptions to match the highest height
      this.productDescriptions.forEach(description => {
        description.style.height = maxHeight + 'px';
      });

      this.productAttributes.filter(item => !item.classList.contains('hidden')).forEach(item => {
        let maxHeightAttr = 0;
        let attributeIndex = item.getAttribute('data-product-attr');
        let attributeFields = this.querySelectorAll(`[data-product-attr="${attributeIndex}"]`);

        attributeFields.forEach(field => {
          if (field.getBoundingClientRect().height > maxHeightAttr) {
            maxHeightAttr = field.getBoundingClientRect().height;
          }
        });
        attributeFields.forEach(field => {
          field.style.height = maxHeightAttr + 'px';
        });
      });
    }, timeOut);
    clearTimeout(timeOut);
  }
}
if (!customElements.get('comparison-table')) {
  customElements.define('comparison-table', ComparisonTable);
}